export const companyInfo = {
  name: "GENICONCEPT",
  slogan: "Expertise en génie civil, garantie de qualité",
  phone: "+221 77 768 73 63",
  email: "geniconcepteur@gmail.com",
  address: "43 HLM Grand Médine Dakar Senegal",
  logo: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/zu4js4jt_Logo%20geni.jpeg",
  tiktok: "https://www.tiktok.com/@geniconcept.engin?_r=1&_t=ZM-92n41kxQ1SC",
  whatsapp: "https://wa.me/message/IOJZ6GVHF2LME1",
  description: "GENICONCEPT est une entreprise sénégalaise spécialisée dans le génie civil et les travaux publics. Depuis notre création, nous nous engageons à fournir des services de haute qualité avec un respect strict des normes de sécurité et des délais.",
  mission: "Notre mission est de construire des infrastructures durables et fiables qui répondent aux besoins de nos clients tout en respectant l'environnement et les communautés locales.",
  values: [
    {
      title: "Qualité",
      description: "Nous garantissons un travail de haute qualité sur chaque projet"
    },
    {
      title: "Sécurité",
      description: "La sécurité de nos équipes et clients est notre priorité absolue"
    },
    {
      title: "Respect des délais",
      description: "Nous livrons nos projets dans les temps convenus"
    },
    {
      title: "Innovation",
      description: "Nous adoptons les meilleures pratiques et technologies du secteur"
    }
  ],
  services: [
    {
      id: 1,
      title: "Bâtiment et travaux publics (BTP)",
      description: "Construction et rénovation de bâtiments résidentiels, commerciaux et industriels avec une attention particulière à la qualité et aux normes."
    },
    {
      id: 2,
      title: "Génie civil",
      description: "Conception et réalisation d'ouvrages d'art, ponts, et structures complexes avec expertise technique avancée."
    },
    {
      id: 3,
      title: "Terrassement",
      description: "Préparation de terrains, excavation et nivellement pour tous types de projets de construction."
    },
    {
      id: 4,
      title: "Ouvrages en béton",
      description: "Réalisation de structures en béton armé et précontraint selon les normes les plus strictes."
    },
    {
      id: 5,
      title: "Voirie et réseaux divers (VRD)",
      description: "Aménagement de voies, réseaux d'eau, d'assainissement et d'électricité pour les zones urbaines et rurales."
    }
  ],
  projects: [
    {
      id: 1,
      title: "Villa Design Tropical",
      category: "Villa résidentielle",
      status: "Achevé",
      location: "Mbour",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/o8tb2xwf_WhatsApp%20Image%202026-01-01%20at%2018.11.42%20%281%29.jpeg",
      description: "Villa architecturale exceptionnelle avec piscine multi-niveaux et végétation luxuriante"
    },
    {
      id: 2,
      title: "Résidence Luxe Nocturne",
      category: "Villa résidentielle",
      status: "Achevé",
      location: "Mbour",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/xecq1yyw_WhatsApp%20Image%202026-01-01%20at%2018.11.22%20%281%29.jpeg",
      description: "Villa moderne avec éclairage architectural sophistiqué et piscine illuminée"
    },
    {
      id: 3,
      title: "Villa Moderne Dakar",
      category: "Villa résidentielle",
      status: "Achevé",
      location: "Dakar",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/1rta7ox4_WhatsApp%20Image%202026-01-01%20at%2018.11.23.jpeg",
      description: "Villa contemporaine avec piscine et aménagement paysager complet"
    },
    {
      id: 4,
      title: "Villa Architecturale",
      category: "Villa résidentielle",
      status: "En finition",
      location: "Touba",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/m2pk5juj_WhatsApp%20Image%202026-01-01%20at%2018.03.49.jpeg",
      description: "Design contemporain avec formes ondulées et grandes terrasses"
    },
    {
      id: 5,
      title: "Résidence Prestige",
      category: "Villa résidentielle",
      status: "En finition",
      location: "Touba",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/4pdjhz6u_WhatsApp%20Image%202026-01-01%20at%2018.11.21.jpeg",
      description: "Villa avec grandes baies vitrées et piscine moderne"
    },
    {
      id: 6,
      title: "Villa Palmiers",
      category: "Villa résidentielle",
      status: "Achevé",
      location: "Dakar",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/sgr136v6_WhatsApp%20Image%202026-01-01%20at%2018.11.36%20%281%29.jpeg",
      description: "Résidence moderne avec piscine et aménagement végétal"
    },
    {
      id: 7,
      title: "Maison Familiale",
      category: "Villa résidentielle",
      status: "Achevé",
      location: "Dakar",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/vthw3pbg_WhatsApp%20Image%202026-01-01%20at%2018.03.42.jpeg",
      description: "Villa moderne avec balcons et finitions haut de gamme"
    },
    {
      id: 8,
      title: "Hôtel 5 étoiles",
      category: "Hôtellerie",
      status: "Structure",
      location: "Nguaparou",
      type: "video",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/if4dco0x_Hotel%205%20Etoile%20Nguap.mp4",
      description: "Complexe hôtelier de luxe en construction avec infrastructures modernes"
    },
    {
      id: 9,
      title: "Villa Résidentiel",
      category: "Villa résidentielle",
      status: "Structure",
      location: "Malicounda",
      type: "video",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/82wk2mrt_villa%20resi%2C%20Malicoun.mp4",
      description: "Villa résidentielle moderne en phase de structure"
    },
    {
      id: 10,
      title: "Résidence en Construction",
      category: "Projet en cours",
      status: "Gros œuvre",
      location: "Touba",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/n2vpezo1_WhatsApp%20Image%202026-01-01%20at%2018.11.34.jpeg",
      description: "Structure en béton et travaux de gros œuvre"
    },
    {
      id: 11,
      title: "Villa Contemporaine",
      category: "Projet en cours",
      status: "Structure",
      location: "Mbour",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/exb0cxhl_WhatsApp%20Image%202026-01-01%20at%2018.11.35.jpeg",
      description: "Montage de la structure et travaux de charpente"
    },
    {
      id: 12,
      title: "Pose BA13 - Finition",
      category: "Projet en cours",
      status: "En finition",
      location: "Dakar",
      type: "video",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/y5529ltr_pose%20Ba1.mp4",
      description: "Travaux de finition intérieure avec pose de plaques BA13 et aménagements"
    },
    {
      id: 13,
      title: "Projet Villa Terrassement",
      category: "Projet en cours",
      status: "Terrassement",
      location: "Dakar",
      type: "image",
      image: "https://customer-assets.emergentagent.com/job_ingenierie-tp/artifacts/e0lnbodh_WhatsApp%20Image%202026-01-01%20at%2018.11.37.jpeg",
      description: "Travaux de terrassement et préparation piscine"
    }
  ]
};
